import React from 'react';

const BadgeLogo = ({ badge, size = 150, customerName }) => {
  const color = badge.color || '#D4A017';
  const symbol = badge.iconKey === 'AMBASSADOR' ? '★' : badge.iconKey === 'CONSISTENCY' ? '✓' : '🏆';
  return <div style={{ ...styles.wrap, width: size, minHeight: size, borderColor: color, background: `linear-gradient(145deg, ${color}22, #fff 58%, ${color}18)` }}>
    <div style={{ ...styles.ribbon, background: color }}>RECOGNITION</div>
    <div style={{ ...styles.medal, borderColor: color, color }}>{symbol}</div>
    <strong style={{ ...styles.name, fontSize: Math.max(13, size / 10) }}>{badge.name}</strong>
    {customerName && <span style={styles.customer}>{customerName}</span>}
    <span style={{ ...styles.seal, color }}>ACHIEVEMENT AWARD</span>
  </div>;
};

const styles = {
  wrap: { boxSizing: 'border-box', border: '3px solid', borderRadius: 24, padding: '20px 12px 14px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, textAlign: 'center', position: 'relative', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,.12)' },
  ribbon: { position: 'absolute', top: 0, left: 0, right: 0, color: '#fff', fontSize: 9, fontWeight: 900, letterSpacing: 1.5, padding: 5 },
  medal: { width: 52, height: 52, display: 'grid', placeItems: 'center', border: '4px solid', borderRadius: '50%', background: '#fff', fontSize: 25, marginTop: 8 },
  name: { color: '#263522', lineHeight: 1.15 }, customer: { fontSize: 11, color: '#596554', fontWeight: 700 }, seal: { fontSize: 8, letterSpacing: 1, fontWeight: 900 }
};
export default BadgeLogo;
